import React, { useState } from 'react';
import { List, ListItem, ListItemIcon, ListItemText, IconButton, Typography, Divider, Box } from '@mui/material';
import { Schedule, People, ChevronLeft, ChevronRight } from '@mui/icons-material';
import './barraPersonal.css';

export default function BarraPersonal({ onSeleccion }) {
  const [open, setOpen] = useState(true);
  const [seleccionada, setSeleccionada] = useState(null); // 👈 Nuevo estado

  const toggleDrawer = () => setOpen(!open);

  const opciones = [
    { texto: 'Horarios', icono: <Schedule /> },
    { texto: 'Personal', icono: <People /> },
  ];

  const handleSeleccion = (texto) => {
    setSeleccionada(texto);
    onSeleccion(texto.toLowerCase());
  };

  return (
    <Box
      className={`barra-personal ${open ? 'barra-abierta' : 'barra-cerrada'}`}
      sx={{
        width: open ? 240 : 60,
        transition: 'width 0.3s ease',
        height: '100%',
        overflowX: 'hidden',
      }}
    >
      <Box className="barra-titulo d-flex align-items-center justify-content-between p-2">
        {open && <Typography variant="h6">Personal</Typography>}
        <IconButton onClick={toggleDrawer}>
          {open ? <ChevronLeft /> : <ChevronRight />}
        </IconButton>
      </Box>
      <Divider />
      <List>
        {opciones.map((opcion, index) => (
          <ListItem
            button
            key={index}
            className={`barra-item ${seleccionada === opcion.texto ? 'seleccionada' : ''}`}
            onClick={() => handleSeleccion(opcion.texto)}
          >
            <ListItemIcon>{opcion.icono}</ListItemIcon>
            {open && <ListItemText primary={opcion.texto} />}
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
